export default __webpack_public_path__ + "static/media/dlr-logo-gray-400.2a16cfc9.svg";